import { render } from "./QueueList.vue?vue&type=template&id=671997ce"
import script from "./QueueList.vue?vue&type=script&lang=js"
export * from "./QueueList.vue?vue&type=script&lang=js"

import "./QueueList.vue?vue&type=style&index=0&id=671997ce&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__